/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Trendmover_RoleInputs */

const en_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Developer`)
};

const ar_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور تطبيقات`)
};

const bn_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপ ডেভেলপার`)
};

const de_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Entwickler`)
};

const es_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador de aplicaciones`)
};

const fr_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur d'applications`)
};

const pt_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor de aplicativos`)
};

const zh_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用程序开发人员`)
};

const tr_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulama Geliştiricisi`)
};

const ru_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик приложений`)
};

const pl_experience_trendmover_role = /** @type {(inputs: Experience_Trendmover_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twórca aplikacji`)
};

/**
* | output |
* | --- |
* | "App Developer" |
*
* @param {Experience_Trendmover_RoleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_trendmover_role = /** @type {((inputs?: Experience_Trendmover_RoleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Trendmover_RoleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_trendmover_role(inputs)
	if (locale === "bn") return bn_experience_trendmover_role(inputs)
	if (locale === "de") return de_experience_trendmover_role(inputs)
	if (locale === "es") return es_experience_trendmover_role(inputs)
	if (locale === "fr") return fr_experience_trendmover_role(inputs)
	if (locale === "pt") return pt_experience_trendmover_role(inputs)
	if (locale === "zh") return zh_experience_trendmover_role(inputs)
	if (locale === "tr") return tr_experience_trendmover_role(inputs)
	if (locale === "ru") return ru_experience_trendmover_role(inputs)
	if (locale === "pl") return pl_experience_trendmover_role(inputs)
	return en_experience_trendmover_role(inputs)
});